// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardLoadingSpinner-cls1_6Qz","cls2":"BigCardLoadingSpinner-cls2_xyR BigCardLoadingSpinner-cls1_6Qz"};